const fulfillment = Object.freeze({
  EMPTY: 'EMPTY',
  FULL: 'FULL',
  HALF: 'HALF'
})

export { fulfillment }
